module.exports = __webpack_public_path__ + "static/media/comment_discussion.53053bf7.svg";